export default __webpack_public_path__ + "static/media/closedToday.f9e36da3.svg";